import { render, staticRenderFns } from "./multi_imputazioni.vue?vue&type=template&id=075c6665"
import script from "./multi_imputazioni.vue?vue&type=script&lang=js"
export * from "./multi_imputazioni.vue?vue&type=script&lang=js"
import style0 from "./multi_imputazioni.vue?vue&type=style&index=0&id=075c6665&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports